var _style, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNowaWersja(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sunset",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 -3 118.1 55.8",
    style: {
      enableBackground: "new 0 0 118.1 54.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{\r\n        fill:url(#all);\r\n        stroke:#000000;\r\n        stroke-miterlimit:10;\r\n    }\r\n    ", "\r\n\t.st1{\r\n        ", "\r\n\r\n    }\r\n\t\r\n\t#Warstwa_1{\r\n            transform: translate(50%, 15px);\t\r\n        }\r\n    #Warstwa_2{\r\n            transform: translate(50%, 50px);\r\n            \r\n\t\t\t\r\n        }\r\n  \r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "all",
    gradientUnits: "userSpaceOnUse",
    x1: -40.1,
    y1: 154.3713,
    x2: 40.1,
    y2: 154.3713,
    gradientTransform: "matrix(1 0 0 -1 0 171.9213)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop",
    offset: 0,
    style: {
      stopColor: "rgb(78, 137, 247)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgba(255, 255, 255, 0)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "razem",
    style: {
      fill: "url(#all)",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: " M-0.4,0c-21.9,0-39.7,15.7-39.7,35.1h80.2C40.1,15.8,21.5,0-0.4,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,255,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,0,0)",
      stopOpacity: 1
    }
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "sun",
    className: "st0",
    fill: "url(#grad1)",
    cx: -40.1,
    cy: 0,
    rx: 8.3,
    ry: 8.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowaWersja);
export default __webpack_public_path__ + "static/media/nowa_wersja.facbd93d63e2d7c7c104d0d6b835afc6.svg";
export { ForwardRef as ReactComponent };